export const SYS_SPACE_RELATIVE_2_XS = 'var(--spacing-relative-2xs)';
export const SYS_SPACE_RELATIVE_XS = 'var(--spacing-relative-xs)';
export const SYS_SPACE_RELATIVE_SM = 'var(--spacing-relative-sm)';
export const SYS_SPACE_RELATIVE_MD = 'var(--spacing-relative-md)';
export const SYS_SPACE_RELATIVE_LG = 'var(--spacing-relative-lg)';
export const SYS_SPACE_RELATIVE_XL = 'var(--spacing-relative-xl)';
export const SYS_SPACE_RELATIVE_2_XL = 'var(--spacing-relative-2xl)';
export const SYS_SPACE_RELATIVE_3_XL = 'var(--spacing-relative-3xl)';
export const SYS_SPACE_RELATIVE_4_XL = 'var(--spacing-relative-4xl)';
export const SYS_SPACE_RELATIVE_5_XL = 'var(--spacing-relative-5xl)';
export const SYS_SPACE_RELATIVE_6_XL = 'var(--spacing-relative-6xl)';
export const SYS_SPACE_RELATIVE_7_XL = 'var(--spacing-relative-7xl)';
export const SYS_PAGE_MARGIN = 'var(--page-margin)';
//# sourceMappingURL=index.js.map